orama-chat-messages-container {
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    // TODO: Should it be a variable?
    background-color: #b2b2b285;
    border-radius: var(--border-radius-l, $radius-l);
  }
}

.messages-container {
  display: flex;
  flex-direction: column;
  margin: var(--spacing-l, $spacing-l) 0;
  gap: var(--spacing-xl, $spacing-xl);
  overflow: hidden;
}

.suggestions-wrapper {
  margin-top: var(--spacing-xl, $spacing-xl);
}
